"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorsCustomize = void 0;
var react_1 = __importDefault(require("react"));
var Section_1 = require("../components/Section");
var variables = "$dark: (base: #000, mode: \"dark\", n: 8);\n$light: (base: #fff, mode: \"light\", n: 8);\n$primary: (base: #f2590d, mode: \"full\", n: 8);\n$secondary: (base: #dfc020, mode: \"full\", n: 8);\n\n$colors: (\n  dark: $dark,\n  light: $light,\n  primary: $primary,\n  secondary: $secondary,\n);";
var ColorsCustomize = function () { return (react_1.default.createElement(Section_1.Customize, { variables: variables })); };
exports.ColorsCustomize = ColorsCustomize;
